var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBabies(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_86",
    "data-name": "Grupo 86",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 7.809,
    height: 14.137,
    viewBox: "0 0 7.809 14.137",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_23",
    "data-name": "Ret\\xE2ngulo 23",
    width: 7.809,
    height: 14.137,
    fill: "#35bde8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_85",
    "data-name": "Grupo 85",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_151",
    "data-name": "Caminho 151",
    d: "M7.019,7.534c0-.437,0-.874,0-1.31A1.661,1.661,0,0,0,6.1,4.689,3.716,3.716,0,0,0,5.4,4.4c-.417-.132-.5-.409-.22-.747A1.657,1.657,0,0,0,5.451,1.8,1.625,1.625,0,0,0,3.892.793a1.628,1.628,0,0,0-1.553.974,1.662,1.662,0,0,0,.2,1.823c.021.028.046.052.069.079.275.329.2.6-.2.733a3.336,3.336,0,0,0-.856.385A1.61,1.61,0,0,0,.793,6.175c0,.21,0,.419,0,.629a.392.392,0,0,1-.4.418.389.389,0,0,1-.379-.417A4.788,4.788,0,0,1,.079,5.554,2.457,2.457,0,0,1,1.507,3.913c.17-.08.207-.134.118-.318a2.51,2.51,0,1,1,4.54-.027c-.093.2-.049.255.124.338A2.468,2.468,0,0,1,7.809,6.321c-.008.847,0,1.695,0,2.542A1.243,1.243,0,0,1,6.26,10.217c-.206-.027-.16.1-.161.205,0,.76-.01,1.52,0,2.28a1.3,1.3,0,0,1-.677,1.265A1.234,1.234,0,0,1,4,13.844a.137.137,0,0,0-.2,0,1.238,1.238,0,0,1-1.424.116A1.315,1.315,0,0,1,1.7,12.7c.007-.76,0-1.52,0-2.28,0-.173-.035-.22-.223-.183A1.234,1.234,0,0,1,0,9.031c-.005-.2-.007-.4,0-.6a.4.4,0,0,1,.383-.416.4.4,0,0,1,.4.424c.006.174,0,.349,0,.524a.471.471,0,0,0,.449.511.455.455,0,0,0,.457-.5c.007-.734,0-1.468,0-2.2,0-.087,0-.175,0-.262a.407.407,0,0,1,.391-.438c.225,0,.379.164.4.43,0,.052,0,.1,0,.157,0,.564,0,.564.579.564.673,0,1.346,0,2.018,0,.165,0,.238-.037.224-.216a3.742,3.742,0,0,1,0-.524.4.4,0,0,1,.413-.415A.391.391,0,0,1,6.1,6.5c.005.76,0,1.52,0,2.28,0,.079,0,.158,0,.236a.464.464,0,0,0,.449.458A.456.456,0,0,0,7.014,9c.012-.489,0-.978,0-1.467ZM2.5,9.708c0,1.091-.008,2.128.005,3.163a.484.484,0,0,0,.5.47.514.514,0,0,0,.5-.531c.008-.794,0-1.587,0-2.381,0-.078.007-.152-.094-.188A4.323,4.323,0,0,1,2.5,9.708m0-1.392c.015.126-.048.27.075.387a4.068,4.068,0,0,0,1.049.767.636.636,0,0,0,.578,0,4.606,4.606,0,0,0,.839-.572.675.675,0,0,0,.281-.625c-.011-.2-.049-.267-.261-.263q-1.136.02-2.273,0c-.238,0-.352.051-.288.31M5.263,9.729a3.185,3.185,0,0,1-.793.475.233.233,0,0,0-.173.27c.006.749,0,1.5,0,2.248,0,.385.2.627.516.619s.492-.236.492-.615q0-1.386,0-2.771a.306.306,0,0,0-.045-.226",
    transform: "translate(0 0)",
    fill: "#35bde8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBabies);
export default __webpack_public_path__ + "static/media/babies.4152c331dafa9c4f2549d252b4da1055.svg";
export { ForwardRef as ReactComponent };